<!-- Anything to do with a challenge will inherit this layout. It should be kept pretty bare except for challenge-wide things. -->
<template>
  <div>
    <main
      id="main"
      tabindex="-1"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
</script>